import React, { useContext, useState } from 'react';
import dayjs from 'dayjs';
import {
  Avatar,
  AvatarsGroup,
  Popover,
  Radio,
  RadioGroup,
  Tooltip,
} from '@mantine/core';
import { AuthContext } from 'context/authContext';

import CreateProject from './createProject';
import DeleteProjectModal from './deleteProjectModal';
import DeactivateProjectModal from './deactivateProjectModal';
import ViewProjectModal from './viewProjectModal';

import useUpdateProjectData from '../hooks/useUpdateProject';
import { Link } from 'react-router-dom';

import { ReactComponent as EditIcon } from 'assets/icons/editIcon.svg';
import { ReactComponent as DotsMenu } from 'assets/icons/dotsMenu2.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/timeIcon.svg';
import { ReactComponent as TeamIcon } from 'assets/icons/teamIcon.svg';
import { ReactComponent as LowPriorityIcon } from 'assets/icons/lowPriorityIcon.svg';
import { ReactComponent as HighPriorityIcon } from 'assets/icons/highPriorityIcon.svg';
import { ReactComponent as MediumPriorityIcon } from 'assets/icons/mediumPriorityIcon.svg';
import { ReactComponent as ChannelIcon } from 'assets/icons/ChannelIcon.svg';

export default function ProjectCard({ item }) {
  const [isEditProjectModalOpen, setEditProjectModalOpen] = useState(false);
  const [isDeleteProjectModalOpen, setDeleteProjectModalOpen] = useState(false);
  const [isChangeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [isDeactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [teamMemberPopoverOpened, setTeamMemberPopoverOpened] = useState(false);
  const [channelPopoverOpened, setChannelPopoverOpened] = useState(false);

  const { authState } = useContext(AuthContext);

  const updateProjectMutation = useUpdateProjectData();

  const handleStatusChange = (data) => {
    setChangeStatusModalOpen(false);
    updateProjectMutation.mutate({
      id: item?.id,
      status: data,
    });
  };

  return (
    <div className='border border-gray border-opacity-10 shadow-lg w-full rounded-xl p-4 bg-white h-90  select-none'>
      <div className='flex  items-center   justify-around mx-2'>
        <div
          className='flex items-center  cursor-pointer'
          onClick={() => setViewModalOpen(true)}
        >
          <Avatar
            src={''}
            color='red'
            size={45}
            radius='xl'
            classNames={{
              image: 'border border-primary rounded-full',
              placeholder: 'border border-primary rounded-full ',
            }}
          >
            {item?.title[0]?.toUpperCase()}
          </Avatar>
          <p className='text-[1.5vw] font-semibold text-333333 ml-2 truncate w-40 '>
            {item?.title}
          </p>
        </div>
        <div className='flex items-center space-x-2'>
          <div
            className='flex  items-center cursor-pointer'
            onClick={() => setViewModalOpen(true)}
          >
            {item?.priority === 'High' ? (
              <HighPriorityIcon />
            ) : item?.priority === 'Medium' ? (
              <MediumPriorityIcon />
            ) : (
              <LowPriorityIcon />
            )}
            <p
              className={`${
                item?.priority === 'Medium'
                  ? 'text-success text-sm '
                  : item?.priority === 'High'
                  ? 'text-[#FB0C0C]'
                  : 'text-warning'
              } font-bold text-[1vw]`}
            >
              {item?.priority}
            </p>
          </div>
          {authState?.is_admin ||
          item?.lead__user__id === authState?.user_id ? (
            <EditIcon
              className='cursor-pointer'
              onClick={() => setEditProjectModalOpen(true)}
            />
          ) : null}

          {authState?.is_admin ||
          item?.lead__user__id === authState?.user_id ? (
            <Popover
              opened={isMenuOpened}
              onClose={() => setIsMenuOpened(false)}
              target={
                <div className='px-1 cursor-pointer'>
                  <DotsMenu
                    className='cursor-pointer px-1 w-4'
                    onClick={() => {
                      setIsMenuOpened(true);
                    }}
                  />
                </div>
              }
              width={150}
              position='bottom-end'
              classNames={{
                dropdown: 'p-0',
              }}
            >
              <div className='select-none -mt-1 -mb-1'>
                {/* change project status popover */}
                <Popover
                  opened={isChangeStatusModalOpen}
                  onClose={() => setChangeStatusModalOpen(false)}
                  target={
                    <div className='cursor-pointer'>
                      <p
                        className='text-primary hover:bg-[#f2f2f2] cursor-pointer py-1 mb-2'
                        onClick={() => {
                          setChangeStatusModalOpen(true);
                        }}
                      >
                        Change status
                      </p>
                    </div>
                  }
                  width={180}
                  position='left-start'
                  classNames={{
                    dropdown: 'p-0',
                  }}
                >
                  <div className='select-none -mt-1 -mb-1'>
                    <RadioGroup
                      value={item?.status}
                      onChange={(data) => handleStatusChange(data)}
                      classNames={{
                        label: 'text-9B9B9B cursor-pointer',
                        icon: 'cursor-pointer',
                      }}
                    >
                      <Radio value='Not yet started' label='Not yet started' />
                      <Radio value='In progress' label='In progress' />
                      <Radio value='Almost there' label='Almost there' />
                      <Radio value='Completed' label='Completed' />
                    </RadioGroup>
                  </div>
                </Popover>
                <p
                  className='text-gray hover:bg-[#f2f2f2] cursor-pointer py-1 -mt-1 mb-1'
                  onClick={() => {
                    setIsMenuOpened(false);
                    setDeactivateModalOpen(true);
                  }}
                >
                  {item?.is_active ? 'Deactivate' : 'Activate'}
                </p>
                <p
                  className='text-gray hover:bg-[#f2f2f2] cursor-pointer py-1'
                  onClick={() => {
                    setIsMenuOpened(false);
                    setDeleteProjectModalOpen(true);
                  }}
                >
                  Delete
                </p>
              </div>
            </Popover>
          ) : null}
        </div>
      </div>
      <div
        className='h-14 overflow-hidden cursor-pointer'
        onClick={() => setViewModalOpen(true)}
      >
        <p className='ml-4 mt-2 text-gray3 max-h-20 line-clamp'>
          {item?.description.split(' ')[0].length > 40
            ? item?.description.substring(0, 40) + '...'
            : item?.description}
        </p>
      </div>
      <div
        className='flex space-x-4 items-center pl-4 mt-3 cursor-pointer'
        onClick={() => setViewModalOpen(true)}
      >
        <TimeIcon className='w-4' />
        <p className='text-gray3'>
          Due date - {dayjs(item?.to_date).format('DD MMM YYYY')}{' '}
        </p>
      </div>
      <div className='flex  items-center pl-4 space-x-4 mt-3'>
        <TeamIcon className='w-4' />
        <p className='text-gray3'>
          {item?.members?.length === 1
            ? `${item?.members?.length} member`
            : `${item?.members?.length} members`}{' '}
        </p>
        <div
          className=''
          // onClick={() => {
          //   // setSelectedRow(element);
          //   setTeamMemberPopoverOpened(true);
          // }}
          onMouseEnter={() => {
            setTeamMemberPopoverOpened(true);
          }}
          onMouseLeave={() => {
            setTeamMemberPopoverOpened(false);
          }}
        >
          <AvatarsGroup
            limit={3}
            total={item?.members?.length}
            classNames={{
              truncated: 'bg-FFE8E1',
            }}
          >
            {item?.members?.map((member) => (
              <Avatar
                src={member?.employee__profile_picture}
                color={'red'}
                radius='xl'
                size={100}
                key={member?.id}
                classNames={{
                  image: 'border border-primary rounded-full',
                  placeholder: 'border border-primary rounded-full',
                }}
              >
                {member?.employee__user__first_name[0].toUpperCase()}
              </Avatar>
            ))}
          </AvatarsGroup>
        </div>
      </div>
      <Popover
        opened={teamMemberPopoverOpened}
        onClose={() => setTeamMemberPopoverOpened(false)}
        onMouseEnter={() => {
          setTeamMemberPopoverOpened(true);
        }}
        onMouseLeave={() => {
          setTeamMemberPopoverOpened(false);
        }}
        width={240}
        title='Team Members'
        position='right-end'
        placement='center'
        radius='sm'
        classNames={{
          inner: 'py-2 max-h-48 overflow-y-scroll scroller',
          header: 'border-b-0 text-accent font-medium',
          body: 'shadow-four',
        }}
        className='z-0'
      >
        {item?.members?.map((member) => {
          return (
            <div className='flex space-x-2 pb-4'>
              <Avatar
                src={member?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-10 h-10'
              >
                {member?.employee__user__first_name?.substring(0, 1)}
              </Avatar>
              <div className='text-xs mt-1 '>
                <p className='text-121212 w-40 truncate'>
                  {member?.employee__user__first_name}
                </p>
                <p className='text-868686'>
                  {member?.employee__designation__name}
                </p>
              </div>
            </div>
          );
        })}
      </Popover>
      {item?.project_tboard?.length !== 0 ? (
        <React.Fragment>
          <div className='flex  items-center pl-4 space-x-4 -mb-2'>
            <ChannelIcon className='w-4' />
            <p className='text-gray3'>
              {item?.project_tboard?.length === 1
                ? `${item?.project_tboard?.length} channel`
                : `${item?.project_tboard?.length} channels`}
            </p>
            <div
              className=''
              // onClick={() => {
              //   // setSelectedRow(element);
              //   setTeamMemberPopoverOpened(true);
              // }}
              onMouseEnter={() => {
                setChannelPopoverOpened(true);
              }}
              onMouseLeave={() => {
                setChannelPopoverOpened(false);
              }}
            >
              <AvatarsGroup
                limit={3}
                total={item?.project_tboard?.length}
                classNames={{
                  truncated: 'bg-FFE8E1',
                }}
              >
                {item?.project_tboard?.map((channel) => (
                  <Avatar
                    color={'red'}
                    radius='xl'
                    size={40}
                    key={channel?.id}
                    classNames={{
                      image: 'border border-primary rounded-full',
                      placeholder: 'border border-primary rounded-full ',
                    }}
                  >
                    {channel?.name[0]?.toUpperCase()}
                  </Avatar>
                ))}
              </AvatarsGroup>
            </div>
          </div>
          <Popover
            opened={channelPopoverOpened}
            onClose={() => setChannelPopoverOpened(false)}
            onMouseEnter={() => {
              setChannelPopoverOpened(true);
            }}
            onMouseLeave={() => {
              setChannelPopoverOpened(false);
            }}
            width={200}
            title='Channels'
            position='right-end'
            placement='center'
            radius='sm'
            classNames={{
              inner: 'py-2 max-h-48 overflow-y-scroll scroller',
              header: 'border-b-0 text-accent font-medium',
              body: 'shadow-four',
            }}
            className='z-0'
          >
            {item?.project_tboard?.map((channel) => {
              return (
                <div className='flex space-x-2 pb-4'>
                  <Avatar
                    color='#EEF3F1'
                    radius='xl'
                    size={30}
                    classNames={{
                      placeholder: 'text-xl',
                    }}
                  >
                    {channel?.name?.substring(0, 1)}
                  </Avatar>
                  <div className='text-xs mt-1 '>
                    <Tooltip
                      label='visit channel'
                      position='top-start'
                      openDelay={200}
                      classNames={{
                        body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                      }}
                      radius='md'
                    >
                      <Link
                        to={`/app/projects/task-board/${channel?.id}?filter=bucket`}
                        state={{ name: channel?.name }}
                      >
                        <div className='text-xs mt-1 '>
                          <p className='text-121212  truncate'>
                            {channel?.name}
                          </p>
                        </div>
                      </Link>
                    </Tooltip>
                  </div>
                </div>
              );
            })}
          </Popover>
        </React.Fragment>
      ) : (
        <p className='text-[#707070]   pl-4 mt-3 mb-8'>
          No channel for this project
        </p>
      )}

      <div
        className='flex justify-around space-x-12 items-center  mt-3'
        onClick={() => setViewModalOpen(true)}
      >
        <div className='flex space-x-2 items-center'>
          <Avatar
            src={item?.lead__profile_picture}
            color='red'
            size={40}
            radius='xl'
          >
            {item?.lead__user__first_name[0]?.toUpperCase()}
          </Avatar>
          <div>
            <p className='text-[#707070] truncate w-40'>
              {item?.lead__user__first_name}
            </p>
            <p className='text-sm text-[#969696]'>Project Lead</p>
          </div>
        </div>

        <div className='w-[5vw] flex flex-col justify-center '>
          <p
            className={`${
              item?.status === 'Not yet started'
                ? 'text-[#DD0F1B]'
                : item?.status === 'In progress'
                ? 'text-warning'
                : 'text-success'
            }  text-xs text-right block pb-1.5 font-bold`}
          >
            {item?.status}
          </p>
          <div className='flex space-x-1'>
            <span
              className={`${
                item?.status === 'Not yet started'
                  ? 'bg-[#E0E0E0]'
                  : 'bg-primary'
              } w-10 h-1.5 rounded-full`}
            ></span>
            <span
              className={`${
                item?.status === 'Not yet started' ||
                item?.status === 'In progress'
                  ? 'bg-[#E0E0E0]'
                  : 'bg-primary'
              } w-10 h-1.5 rounded-full`}
            ></span>
            <span
              className={`${
                item?.status === 'Completed' ? 'bg-primary' : 'bg-[#E0E0E0]'
              } w-10 h-1.5 rounded-full`}
            ></span>
          </div>
        </div>
      </div>
      {isEditProjectModalOpen && (
        <CreateProject
          isModalOpen={isEditProjectModalOpen}
          setIsModalOpen={setEditProjectModalOpen}
          projectDetails={item}
          name='Edit'
        />
      )}
      <DeleteProjectModal
        isModalOpen={isDeleteProjectModalOpen}
        setIsModalOpen={setDeleteProjectModalOpen}
        projectDetails={item}
      />

      <DeactivateProjectModal
        isModalOpen={isDeactivateModalOpen}
        setIsModalOpen={setDeactivateModalOpen}
        projectDetails={item}
      />
      <ViewProjectModal
        isModalOpen={isViewModalOpen}
        setIsModalOpen={setViewModalOpen}
        projectDetails={item}
      />
    </div>
  );
}
